import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/components/HomeIndex'
import SearchIndex from '@/components/SearchIndex'
import DetailIndex from '@/components/DetailIndex'
import ModuleMain from '@/components/ModuleMain'
import ModuleIndex from '@/components/ModuleIndex'
import ModuleListIndex from '@/components/ModuleListIndex'
import NotFound from '@/components/NotFoundView'
import Report from '@/components/Report'
import ReportQuestion from '@/components/reportQuestion'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex
    }, {
      path: '/qsxf-web/search',
      name: 'SearchIndex',
      component: SearchIndex
    }, {
      path: '/qsxf-web/report',
      name: 'Report',
      component: Report
    }, {
      path: '/qsxf-web/reportQuestion',
      name: 'ReportQuestion',
      component: ReportQuestion
    }, {
      path: '/qsxf-web/detail',
      name: 'DetailIndex',
      component: DetailIndex
    }, {
      path: '/qsxf-web/module',
      component: ModuleMain,
      children: [
        { path: 'index', component: ModuleIndex },
        { path: 'list', component: ModuleListIndex }
      ]
    },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js